import React, { useMemo } from "react";
import Slider from "react-slick";
import Image from "next/image";
import Avatar from "@/images/avatar.png";
import Link from "next/link";
import { RxArrowTopRight } from "react-icons/rx";
import { useTranslation } from "next-i18next";
import { trackApplyButton } from "@/utils/dataLayer";
import KananKarimli from "@/images/students/Kanan_Karimli.jpg";
import FidanHasanova from "@/images/students/Fidan_Hasanova.jpg";
import EbruBandaliyeva from "@/images/students/Ebru_Bandaliyeva.jpeg";
import FatimaGasimova from "@/images/students/Fatima_Gasimova.jpg";
import IlqarFerhadov from "@/images/students/İlqar_Ferhadov.jpg";
import MeryemMurshudlu from "@/images/students/Meryem_Murshudlu.jpeg";
import NamiqPashayev from "@/images/students/Namiq_Pashayev.jpeg";


const testimonials = [
    { id: 1, linkedin: null, image: KananKarimli },
    { id: 2, linkedin: "https://www.linkedin.com/in/fidannhasanova?utm_source=share_via&utm_content=profile&utm_medium=member_android", image: FidanHasanova },
    { id: 3, linkedin: null, image: FatimaGasimova },
    { id: 4, linkedin: "https://www.linkedin.com/in/ebru-bendeliyeva-5b1045274?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app", image: EbruBandaliyeva },
    { id: 5, linkedin: "https://www.linkedin.com/in/maryam-murshudlu-88745a251?utm_source=share_via&utm_content=profile&utm_medium=member_android", image: MeryemMurshudlu },
    { id: 6, linkedin: "https://www.linkedin.com/in/npashayev", image: NamiqPashayev },
    { id: 7, linkedin: "https://www.linkedin.com/in/ilqar-ferhadov-29511a2b4?utm_source=share_via&utm_content=profile&utm_medium=member_android", image: IlqarFerhadov },
    { id: 11, linkedin: null, image: "/images/graduates/Mirhuseyn_Talibzada.jpg" },
];

const StudentsFeedbacks = () => {
    const sliderItems = useMemo(() => [...testimonials, ...testimonials], []);
    const { t } = useTranslation();
    const sliderSettingsLeft = {
        centerMode: true,
        dots: false,
        infinite: true,
        speed: 3500,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        variableWidth: true,
        autoplaySpeed: 0,
        cssEase: "linear",
    };

    /*
    const sliderSettingsRight = {
        centerMode: true,
        dots: false,
        infinite: true,
        speed: 3500,
        slidesToScroll: 1,
        slidesToShow: 4,
        arrows: false,
        autoplay: true,
        variableWidth: true,
        autoplaySpeed: 0,
        cssEase: "linear",
        rtl: true,
    };
    */

    const renderCard = (item, index) => (
        <div key={`${item.id}-${index}`} className="px-4 cursor-pointer !w-[300px] md:!w-[400px] lg:!w-[580px]">
            <div className="bg-white p-6 sm:p-8 rounded-[16px] shadow-sm border border-[#FFF/0.08] h-full flex flex-col">
                <div className="flex justify-between items-start md:items-center mb-4 md:flex-row flex-col gap-[10px]">
                    <div className="flex items-center gap-[10px]">
                        <div className="flex items-center justify-center rounded-full w-[30px] h-[30px] md:w-[48px] md:h-[48px] overflow-hidden shrink-0 bg-gray-100">
                            <Image src={item.image || Avatar} alt={t(`students-feedbacks.feedback-${item.id}-name`)} width={48} height={48} loading="lazy" className="object-cover w-full h-full object-top" />
                        </div>
                        <div>
                            <h3 className="text-[12px] md:text-[18px] font-[600] text-[#181E35]">
                                {t(`students-feedbacks.feedback-${item.id}-name`)}
                            </h3>   
                        </div>
                    </div>
                    {item.linkedin && (
                        <Link
                            href={item.linkedin}
                            target="_blank"
                            className="w-[75px] h-[24px] md:w-[120px] md:h-[32px] flex items-center justify-center gap-1 px-3 rounded-full border border-[#E5E5E5] hover:opacity-80 transition cursor-pointer shrink-0"
                        >
                            <span className="text-[10px] md:text-[14px] font-[500] text-[#718096]">
                                Linkedin
                            </span>
                            <RxArrowTopRight className="w-[12px] h-[12px] md:w-[20px] md:h-[20px] text-[#718096]" />
                        </Link>
                    )}
                </div>
                <p className="text-[12px] md:text-[16px] text-[#4B5563] leading-relaxed flex-grow">
                    {t(`students-feedbacks.feedback-${item.id}-text`)}
                </p>
            </div>
        </div>
    );

    return (
        <section className="mb-[80px] md:mb-[150px] bg-white">
            <div className="max-w-[90%] mx-auto">
                <div className="flex flex-col md:items-center md:flex-row justify-between gap-6 mb-[60px]">
                    <div>
                        <h2 className="text-[32px] sm:text-[48px] lg:text-[64px] font-[500] text-main-pink leading-tight text-center md:text-left">
                            {t("home-page.students-feedbacks-title-1")}
                        </h2>
                        <h2 className="text-[32px] sm:text-[48px] lg:text-[64px] font-[500] text-transparent bg-clip-text bg-gradient-to-b from-[#091F59] to-[#1A3884] leading-tight text-center md:text-left">
                            {t("home-page.students-feedbacks-title-2")}
                        </h2>
                    </div>
                    <Link href="/apply" onClick={() => trackApplyButton("students_feedbacks")}>
                        <button className="w-full md:w-[200px] h-[48px] md:h-[56px] flex items-center justify-center gap-2 px-6  border border-[#274DE0] rounded-full text-[#274DE0] text-[14px] sm:text-[16px] font-[500] transition-all duration-300 cursor-pointer hover:!bg-[#274DE0] hover:!text-white">
                            {t("join-us")}
                            <RxArrowTopRight className="w-[20px] h-[20px] md:w-[24px] md:h-[24px]" />
                        </button>
                    </Link>
                </div>
                <div className="mb-6">
                    <Slider {...sliderSettingsLeft} className="students-feedback-slider">
                        {sliderItems.map((item, index) => renderCard(item, index))}
                    </Slider>
                </div>
                {/*
                <div>
                    <Slider {...sliderSettingsRight} className="students-feedback-slider">
                        {sliderItems.map((item, index) => renderCard(item, index))}
                    </Slider>
                </div>
                */}
            </div>
        </section>
    );
};

export default StudentsFeedbacks;
